export class CitySearchRequest{
    searchTerm: string;
    country: string;
}

export class CountrySearchRequest{
    searchTerm: string;
}